import { render, staticRenderFns } from "./receiversSetting.vue?vue&type=template&id=2f819f27&scoped=true"
import script from "./receiversSetting.vue?vue&type=script&lang=ts"
export * from "./receiversSetting.vue?vue&type=script&lang=ts"
import style0 from "./receiversSetting.vue?vue&type=style&index=0&id=2f819f27&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f819f27",
  null
  
)

export default component.exports